// Performance monitoring utilities
export const measurePerformance = (name: string, fn: () => void) => {
  if (typeof performance !== 'undefined' && performance.mark) {
    performance.mark(`${name}-start`);
    fn();
    performance.mark(`${name}-end`);
    performance.measure(name, `${name}-start`, `${name}-end`);
  } else {
    fn();
  }
};

// Monitor Core Web Vitals
export const monitorWebVitals = () => {
  if (typeof window !== 'undefined' && 'web-vitals' in window) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      // Core Web Vitals are monitored but not logged to console in production
      const report = (_metric: any) => {
        // You could send this to an analytics service here
      };
      getCLS(report);
      getFID(report);
      getFCP(report);
      getLCP(report);
      getTTFB(report);
    });
  }
};

// Monitor bundle loading performance
export const monitorBundlePerformance = () => {
  if (typeof performance !== 'undefined' && typeof performance.getEntriesByType === 'function') {
    // Bundle performance logic can be added here if needed for analytics
  }
};

// Optimize third-party scripts loading
export const optimizeThirdPartyScripts = () => {
  // Defer Google Analytics loading
  const gaScript = document.querySelector('script[src*="googletagmanager.com"]');
  if (gaScript) {
    gaScript.setAttribute('defer', 'true');
  }
  
  // Add loading="lazy" to iframes
  const iframes = document.querySelectorAll('iframe');
  iframes.forEach(iframe => {
    if (!iframe.hasAttribute('loading')) {
      iframe.setAttribute('loading', 'lazy');
    }
  });
};

// Initialize performance monitoring
export const initPerformanceMonitoring = () => {
  if (process.env.NODE_ENV === 'development') {
    monitorWebVitals();
    monitorBundlePerformance();
  }
  optimizeThirdPartyScripts();
};

